<template>
  <assistent-template-picker
    :is-submitting="isSubmitting"
    @select-template="onSelectTemplate"
  />
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import AssistentTemplatePicker from './AssistentTemplatePicker';

const stripDescriptionHtml = html => {
  if (!html) return '';
  return html
    .replace(/<li>/gi, '- ')
    .replace(/<\/li>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/\n{2,}/g, '\n')
    .trim();
};

export default {
  components: {
    AssistentTemplatePicker,
  },
  mixins: [alertMixin],
  props: {
    onClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    async buildFormDataFromTemplate(template) {
      const formData = new FormData();
      formData.append('assistent[name]', template.name);
      formData.append(
        'assistent[description]',
        stripDescriptionHtml(template.description)
      );
      formData.append('assistent[model]', template.model);
      formData.append('assistent[temperature]', 1.0);
      formData.append('assistent[top_p]', 1.0);
      formData.append('assistent[active]', true);
      formData.append('assistent[instructions]', template.instructions);
      formData.append(
        'assistent[tools]',
        JSON.stringify([{ type: 'code_interpreter' }])
      );
      formData.append(
        'assistent[tool_resources]',
        JSON.stringify({ code_interpreter: { file_ids: [] } })
      );
      formData.append('assistent[version]', 'v2');
      formData.append('assistent[faqs]', JSON.stringify(template.faqs || []));
      formData.append(
        'assistent[macros]',
        JSON.stringify(template.macros || [])
      );

      const resolutionRules = (template.resolution_rules || []).filter(Boolean);
      if (resolutionRules.length > 0) {
        resolutionRules.forEach(rule =>
          formData.append('assistent[resolution_rules][]', rule)
        );
      } else {
        formData.append('assistent[resolution_rules][]', '');
      }

      const handoffRules = (template.handoff_rules || []).filter(Boolean);
      if (handoffRules.length > 0) {
        handoffRules.forEach(rule =>
          formData.append('assistent[handoff_rules][]', rule)
        );
      } else {
        formData.append('assistent[handoff_rules][]', '');
      }

      formData.append(
        'assistent[resume_instructions]',
        template.resume_instructions || ''
      );

      try {
        const avatarBlob = await fetch(template.avatar).then(response =>
          response.blob()
        );
        const avatarFile = new File([avatarBlob], `${template.id}.png`, {
          type: avatarBlob.type || 'image/png',
        });
        formData.append('assistent[avatar]', avatarFile);
      } catch (error) {
        console.warn('Error fetching avatar image:', error);
      }

      return formData;
    },
    async onSelectTemplate(template) {
      this.isSubmitting = true;
      try {
        const formData = await this.buildFormDataFromTemplate(template);
        await this.$store.dispatch('assistent/create', formData);
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.ASSISTENT.ADD.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const message =
          error.response.data.message ||
          this.$t('INTEGRATION_SETTINGS.ASSISTENT.EDIT.API.ERROR_MESSAGE');
        this.showAlert(message);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>